import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Equity",
  "lead": "لقد تم تحقيق تقدم عالمي نحو تحقيق التكافؤ بين الجنسين في التعليم، ولكن الفجوات لا تزال تتسع بين أولئك في المناطق الريفية والحضرية، وبين الأغنياء والفقراء."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, IndicatorReference, PageLink, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky, Tooltip} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!PageLink) _missingMdxReference("PageLink", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!Tooltip) _missingMdxReference("Tooltip", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_EQUITY"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "إن الرغبة في عدم ترك أي أحد خلف الركب تتقاطع مع أهداف التنمية المستدامة وتتجلى بوضوح في الهدف الخامس من الهدف الرابع الخاص بالتعليم. ويضمن هذا التركيز أن يعطي صناع السياسات الأولوية لمد يد العون لمن هم أكثر تخلفًا عن الركب أولًا."
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["لكي نتمكن من مراقبة ما إذا كانت فجوات التعليم يتم سدها، نحتاج إلى بيانات مقسمة تحت ", _jsx(_components.strong, {
        children: "حسب الدخل والجنس والعمر والعرق والانتماء العرقي وحالة الهجرة والإعاقة والموقع الجغرافي وغيرها من الخصائص"
      }), " ذات الصلة بالسياقات الوطنية، التي توفرها مسوحات الأسر."]
    }), "\n", _jsxs(_components.p, {
      children: ["منذ عام 2010، استعانت ", _jsx(_components.a, {
        href: "https://www.education-inequality.org/",
        children: "قاعدة بيانات عدم المساواة في التعليم في العالم"
      }), " بمسوحات الأسر.لإظهار مدى اتساع فجوات التعليم في مختلف البلدان. يلخص هذا المقال بعض الحقائق والاتجاهات الرئيسية فيما يتعلق بعدم المساواة في التعليم، في حين تتم مناقشة بعض الجوانب الإضافية في المقال حول ", _jsx(PageLink, {
        name: "finance",
        children: "التمويل"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "الجنس",
      children: "الجنس"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.5.1",
      children: [_jsxs(_components.p, {
        children: ["وتتناول الرسوم البيانية أدناه الفجوات التعليمية بين المجموعات، مثل الفتيات والفتيان، أو بين الأفقر والأغنى. فهي تقيس الهوة التعليمية باستخدام ", _jsx(Tooltip, {
          title: "مؤشر التكافؤ",
          content: "في مؤشر التكافؤ، إذا كانت القيمة قريبة من 0، فهذا يدل على أن المجموعة المحرومة متأخرة للغاية؛ والقيم القريبة من 1 تعني وجود التكافؤ؛ والقيم القريبة من 2 تعني أن المجموعة المتميزة هي الأكثر تخلفًا. على سبيل المثال، قد يظهر مؤشر التكافؤ بنسبة 0.5 تسجيل نسبة 30% من الفتيات و60% من الفتيان في المدارس. ويدل مؤشر التكافؤ البالغ 1.5 إلى أن نسبة المسجلين من الأولاد بلغت 30%، في حين بلغت نسبة المسجلين من الفتيات 60%.",
          children: "مؤشر التكافؤ"
        }), "."]
      }), _jsxs(_components.p, {
        children: ["برغم أنه نادرًا ما يتم تقدير ذلك، إلا أنه ثمة حركة مستمرة باتجاه ", _jsx(Tooltip, {
          title: "التكافؤ بين الجنسين",
          content: "حيث توجد أعداد متساوية من الفتيان إلى الفتيات",
          children: "التكافؤ بين الجنسين"
        }), " في الجيل الماضي. إن عدد البنات والنساء الشابات في العديد من المناطق، خاصة الفئات الغنية منها، في العالم يفوق عدد الأولاد والشباب في المدارس والجامعات."]
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "GPITREND"
          })
        }), _jsx(ScrollySection, {
          id: "income,0",
          children: _jsxs(_components.p, {
            children: ["أي خط يقع أسفل منطقة ", _jsx(HighlightByIndex, {
              index: "-1",
              children: "المظللة باللون الرمادي"
            }), " يشير إلى أن عدد الأولاد أو الشباب المسجلين أكبر من عدد الفتيات."]
          })
        }), _jsx(ScrollySection, {
          id: "geo,1",
          children: _jsxs(_components.p, {
            children: ["وفي منطقة ", _jsx(HighlightByIndex, {
              index: "0",
              children: "أفريقيا جنوب الصحراء الكبرى"
            }), " لا يزال هناك أقل من أربع فتيات لكل خمسة شبان يلتحقن بالتعليم العالي."]
          })
        }), _jsx(ScrollySection, {
          id: "geo,2",
          children: _jsxs(_components.p, {
            children: [_jsx(HighlightByIndex, {
              index: "2",
              children: "إن منطقة وسط وجنوب آسيا"
            }), " قد انتقلت\nمن التخلف الشديد عن الفتيات في عام 1990 إلى تحقيق التكافؤ بين الجنسين في التعليم الابتدائي والعالي،\nويرجع ذلك في المقام الأول إلى التقدم الهائل الذي أحرزته الهند. ونتيجة لذلك، تفوقت المنطقة على ", _jsx(HighlightByIndex, {
              index: "0",
              children: "أفريقيا جنوب الصحراء الكبرى"
            }), " في التقدم نحو تحقيق التكافؤ بين الجنسين."]
          })
        })]
      }), _jsx(_components.p, {
        children: "وعلى الصعيد العالمي، تم إحراز تقدم هائل منذ عام 2000. ومع ذلك، فإن سبر أغوار البلدان يكشف عن فجوات مستمرة: فلم تحقق سوى دولتان من كل ثلاث دول التكافؤ بين الجنسين في الالتحاق بالتعليم الابتدائي، وأقل من دولة واحدة من كل دولتين في التعليم الثانوي الأدنى، وواحدة من كل خمس دول في التعليم الثانوي."
      }), _jsxs(_components.p, {
        children: ["لقد انخفضت حصة البلدان التي تشهد ", _jsx(HighlightByIndex, {
          index: "2",
          children: "تفاوتًا شديدًا على حساب الفتيات"
        }), " إلى النصف على الأقل في التعليم الابتدائي إلى العالي منذ عام 2000، ولكنها لا تزال ثابتة عند 3% في التعليم الابتدائي، و6% في التعليم الإعدادي، و12% في التعليم الثانوي."]
      }), _jsxs(_components.p, {
        children: ["لا يجب أن ننسى الفتيان عندما نتحدث عن التكافؤ بين الجنسين. في حين أنه أقل شيوعا في البلدان أن يكون هناك ", _jsx(HighlightByIndex, {
          index: "0",
          children: "تفاوت كبير على حساب الأولاد "
        }), " في التعليم الابتدائي، فإنه أكثر شيوعًا في التعليم الثانوي وما فوق."]
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "PARITYCOUNT"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["في هذا الرسم البياني، كلما كان الجزء الأزرق من الشريط أكبر وأكثر قتامة، زاد عدد البلدان التي يزيد فيها ", _jsx(HighlightByIndex, {
              index: "0",
              children: "عدد الأولاد خارج التعليم"
            }), " عن عدد الفتيات. كلما كان الجزء الأخضر من الشريط أكبر وأكثر قتامة، زاد عدد البلدان التي ", _jsx(HighlightByIndex, {
              index: "2",
              children: "يزيد فيها عدد الفتيات خارج التعليم"
            }), " عن عدد الأولاد."]
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["على سبيل المثال، في التعليم العالي، يعاني ما يقرب من ثلثَي البلدان من ", _jsx(HighlightByIndex, {
              index: "0",
              children: "تفاوت شديد على حساب الأولاد"
            }), "."]
          })
        })]
      }), _jsx(_components.h2, {
        id: "الثروة",
        children: "الثروة"
      }), _jsx(_components.p, {
        children: "وبشكل عام، فإن الفجوات التعليمية بين الفتيات والفتيان ليست واسعة بقدر الفجوة بين أولئك في المناطق الريفية والحضرية، وبين الأغنياء والفقراء، وهو ما تساعد المسوحات الأسرية في الكشف عنه."
      }), _jsxs(_components.p, {
        children: ["في بنجلاديش، على سبيل المثال، بينما يكمل 92% من ", _jsx(HighlightByIndex, {
          index: "0",
          children: "الأغنى"
        }), " التعليم الابتدائي، فإن 70% فقط من ", _jsx(HighlightByIndex, {
          index: "1",
          children: "الأفقر"
        }), " يكملونه. في نيجيريا، بينما يكمل 94% من الأفراد الأغنى تعليمهم الثانوي، فإن 27% فقط من الأفراد الأفقر يكملون تعليمهم الثانوي."]
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "PSECWGAP"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["تُظهر النقاط الحمراء النسبة المئوية للأطفال أو الشباب ", _jsx(HighlightByIndex, {
              index: "1",
              children: "الأفقر"
            }), " الذين يواظبون على التعليم مقارنةً ", _jsx(HighlightByIndex, {
              index: "0",
              children: "بالأغنى"
            }), " – على النحو الموضح باللون الأزرق. يمكنك تغيير المستوى التعليمي من التعليم الابتدائي إلى التعليم الإعدادي وما فوق في أعلى الرسم البياني."]
          })
        }), _jsx(ScrollySection, {
          id: "SRB",
          children: _jsxs(_components.p, {
            children: ["وفي مجال التعليم العالي، تكون الفجوات أوسع في البلدان ذات الدخول المتوسطة. على سبيل المثال، في ", _jsx(_components.strong, {
              children: "صربيا"
            }), "، استطاع 77% من الأفراد الأغنى، وأقل من 28% من الأفراد الأفقر، الالتحاق بأي شكل من أشكال التعليم ما بعد الثانوي."]
          })
        }), _jsx(ScrollySection, {
          id: "COL",
          children: _jsxs(_components.p, {
            children: ["في ", _jsx(_components.strong, {
              children: "كولومبيا"
            }), "، بلغت النسبتان على التوالي 64% و7%."]
          })
        })]
      }), _jsx(_components.p, {
        children: "ومن الأكثر إثارة للاهتمام أن ننظر إلى الطريقة التي تتغير بها الفجوات مع تقدم الأطفال في تعليمهم."
      }), _jsxs(_components.p, {
        children: ["إن النظر في الفجوات بين ", _jsx(_components.strong, {
          children: "الجنسين"
        }), " في ", _jsx(HighlightByIndex, {
          index: "0",
          children: "بنين"
        }), " أدناه يوضح مدى تسرب الفتيات من التعليم كلما ارتفع مستوى التعليم."]
      }), _jsxs(_components.p, {
        children: ["وبدلًا من ذلك، يُظهر اختيار ", _jsx(_components.strong, {
          children: "الثروة"
        }), " مدى تراكم الهوات على مدار المسار التعليمي على حساب الأفراد الأفقر؛ حيث لا يلتحق أي منهم تقريبًا بالتعليم بعد المرحلة الثانوية."]
      }), _jsx(Figure, {
        id: "WLGPI"
      })]
    }), "\n", _jsx(_components.p, {
      children: "نادرًا ما يقع الطفل ضمن فئة واحدة، مما يعني أنه من الأهمية بمكان أيضًا أن ننظر إلى الطريقة التي تتفاعل بها الخصائص الفردية مثل الجنس، مع خصائص أخرى مثل الثروة، كما يفعل الشكل التالي."
    }), "\n", _jsxs(_components.p, {
      children: ["في منطقة أفريقيا جنوب الصحراء الكبرى، تتسع الفجوات بين ", _jsx(HighlightByIndex, {
        index: "1",
        children: "الأفقر"
      }), " ", _jsx(HighlightByIndex, {
        index: "0",
        children: "والأغنى"
      }), " على مدار مسار التعليم؛ حيث يلتحق أقل من 35 من أفقر الفتيات بالتعليم العالي، مقارنةً بنحو 100 من أغنى الفتيات لكل 100 من الأولاد."]
    }), "\n", _jsx(_components.p, {
      children: "ومن ناحية أخرى، في شرق وجنوب شرق آسيا، تتجه النقاط نحو الأعلى من الخط الرمادي؛ لأن الفجوات بين الجنسين تأتي على حساب الأولاد الأكثر فقرًا. وعلى مستوى التعليم العالي، فإن الفتيات الأثرياء أكثر احتمالًا للالتحاق بالمدارس من أقرانهن من الذكور بنحو 35% فقط، ولكن الفتيات الأكثر فقرًا أكثر احتمالًا للالتحاق بالمدارس بنحو 50%."
    }), "\n", _jsx(Figure, {
      id: "GPIBYWEALTH"
    }), "\n", _jsx(_components.h2, {
      id: "خاتمة",
      children: "خاتمة"
    }), "\n", _jsx(_components.p, {
      children: "هناك مستويات غير مقبولة من عدم المساواة في التعليم عبر البلدان وبين المجموعات داخل البلدان. إن البيانات التفصيلية عالية الجودة تشكل شرطًا أساسيًا لتصميم الإستراتيجيات المناسبة للحد من هذه التفاوتات وفي نهاية المطاف عدم ترك أي شخص يتخلف عن الركب في سعينا لتحقيق الهدف الرابع من أهداف التنمية المستدامة."
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.education-inequalities.org/",
            children: "Worldwide Inequalities Database on Education (WIDE) (قاعدة بيانات عدم المساواة العالمية في التعليم"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.unesco.org/gem-report/en/2024genderreport",
            children: "Technology on her terms – GEM Gender Report 2024 (التكنولوجيا بشروطها – التقرير العالمي لرصد التعليم لعام 2024 بشأن الجنسين)"
          })
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.a, {
            href: "https://www.savethechildren.org.uk/content/dam/gb/reports/policy/still-left-behind-low-res.pdf",
            children: "Still left behind – Save the Children (ما زالوا خلف الركب – أنقذوا الأطفال)"
          }), "‏"]
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
